module.exports = __webpack_public_path__ + "media/images/event-hero-img-7e623af4cabb851685b43119dbf204ad.jpg";